import { render, staticRenderFns } from "./mappingManagement.vue?vue&type=template&id=d967cfc8&scoped=true&"
import script from "./mappingManagement.vue?vue&type=script&lang=js&"
export * from "./mappingManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d967cfc8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d967cfc8')) {
      api.createRecord('d967cfc8', component.options)
    } else {
      api.reload('d967cfc8', component.options)
    }
    module.hot.accept("./mappingManagement.vue?vue&type=template&id=d967cfc8&scoped=true&", function () {
      api.rerender('d967cfc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/mappingManagement.vue"
export default component.exports